import React, { Component } from "react";
import PropTypes from "prop-types";
import "./_style.scss";

import CurrencyChip from "components/CurrencyChip/CurrencyChip";
import { IconChevronDown } from "../Icon";

class ImpactSelector extends Component {
  static propTypes = {
    currencySymbol: PropTypes.string.isRequired,
    currency: PropTypes.string.isRequired,
    field: PropTypes.object.isRequired,
    impactLevels: PropTypes.arrayOf(PropTypes.shape({
      amount: PropTypes.number.isRequired,
      id: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
      title: PropTypes.string.isRequired,
    })).isRequired,
    handleImpactChange: PropTypes.func.isRequired,
    handleCurrencyModal: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func,
  };

  state = {
    selectedIndex: null,
  };

  handleChange = (event) => {
    const levelIndex = event.target.getAttribute("data-index");
    const selectedImpactLevel = this.props.impactLevels[levelIndex];

    this.setState({
      selectedIndex: Number.parseInt(levelIndex, 10),
    });

    document.getElementById("impact-selector-option-other").value = "";

    const selectedAmount = Number.parseFloat(event.target.value);

    // Trigger update of optional value to the redux-form field
    if (!this.props.setFieldValue) {
      this.props.field.onChange(selectedAmount, this.props.handleImpactChange(selectedAmount));
    } else {
      this.props.setFieldValue("donationAmount", selectedAmount);
      this.props.setFieldValue("selectedImpactLevel", selectedImpactLevel.id ?? null);
      this.props.handleImpactChange(selectedAmount);
    }
  };

  handleOtherChange = (event) => {
    this.setState({
      selectedIndex: -1,
    });

    const otherValue = Number.parseFloat(event.target.value);
    const otherValueParsed = isNaN(otherValue) ? 0.00 : otherValue.toFixed(2);

    // Trigger update of value to the redux-form field
    if (!this.props.setFieldValue) {
      this.props.field.onChange(otherValueParsed, this.props.handleImpactChange(otherValueParsed));
    } else {
      this.props.setFieldValue("donationAmount", otherValueParsed);
      this.props.handleImpactChange(otherValueParsed);
    }
  };

  handleOtherFocus = (event) => {
    this.setState({
      selectedIndex: -1,
    });

    const selectedAmount = Number.parseFloat(event.target.value);

    // Trigger update of value to the redux-form field
    if (!this.props.setFieldValue) {
      this.props.field.onChange(selectedAmount, this.props.handleImpactChange(0));
    } else {
      this.props.setFieldValue("donationAmount", selectedAmount);
      this.props.handleImpactChange(0);
    }
  };

  render() {
    const {
      currencySymbol,
      currency,
      impactLevels,
      handleCurrencyModal,
    } = this.props;

    const otherActiveClass = this.state.selectedIndex === -1 ? " --active" : "";

    return (
      <div className="impact-selector" data-test="impact-selector">
        <div className="impact-selector__options">
          <div
            className="impact-selector__option --currency-selector"
            data-test="impact-selector-currency-selector"
          >
            <span>
              You're making an impact in
            </span>
            <button
              type="button"
              data-testid="currency-selector__currency-button"
              className="currency-selector__currency-button"
              id="currency-selector-currency-button"
              onClick={handleCurrencyModal}
            >
              <div>
                {currency}
              </div>

              <div className="currency-button-icon">
                <IconChevronDown height="1rem" />
              </div>
            </button>
          </div>

          {
            impactLevels.map((impact, index) => {
              const optionBaseClass = "impact-selector__option";
              const optionClass = this.state.selectedIndex === index ? `${optionBaseClass} --active` : optionBaseClass;

              return (
                <label
                  className={optionClass}
                  htmlFor={`impact-selector-option${index}`}
                  key={index}
                  data-test="impact-selector-item"
                >
                  <CurrencyChip currency={currency} size="medium" hasMargin />
                  <span className="impact-selector__option-amount">
                    {currencySymbol}
                    {impact.amount}
                  </span>
                  <span className="impact-selector__option-title">
                    {impact.title}
                  </span>
                  <input
                    className="impact-selector__option-input"
                    data-index={index}
                    data-test="impact-selector-option"
                    id={`impact-selector-option${index}`}
                    name="impact-amount"
                    onChange={this.handleChange}
                    type="radio"
                    value={impact.amount}
                  />
                </label>
              );
            })
          }
        </div>
        <div className="impact-selector__other">
          <label className={`impact-selector__option-other${otherActiveClass}`} htmlFor="impact-selector-option-other">
            <CurrencyChip currency={currency} size="medium" hasMargin />
            <span className="impact-selector__input-currency">{currencySymbol}</span>
            <input
              className="impact-selector__input-other"
              id="impact-selector-option-other"
              min="0"
              onChange={this.handleOtherChange}
              onFocus={this.handleOtherFocus}
              placeholder="Other amount"
              type="number"
              data-test="impact-selector-option-other"
            />
          </label>
        </div>
      </div>
    );
  }
}

export default ImpactSelector;
